import { render } from "./CartaCursoInscrito.vue?vue&type=template&id=5a9eedc6&scoped=true"
import script from "./CartaCursoInscrito.vue?vue&type=script&lang=js"
export * from "./CartaCursoInscrito.vue?vue&type=script&lang=js"

import "./CartaCursoInscrito.vue?vue&type=style&index=0&id=5a9eedc6&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9eedc6"]])

export default __exports__